var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoneLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93.2 47.1",
    style: {
      enableBackground: "new 0 0 93.2 47.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#E6E7E8;}\r\n\t.st2{fill:#0572BA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,0v47.1h21.7V0H0z M14,32.5l-6.2-8.3v8.3H3.1V14.9h4.8v7.7l5.9-7.7h5.6l-6.5,8.3l7,9.3H14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.7,0v47.1h21.7V0H47.7z M66.5,32.5h-2.4L55,23.6v8.9h-4.4V14.9h2.7l8.8,8.6v-8.6h4.4V32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.7,18.5c-2.5,0-4.5,2.1-4.5,5c0,3,2,5,4.5,5c2.5,0,4.5-2.1,4.5-5C39.2,20.6,37.2,18.5,34.7,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.8,0v47.1h21.7V0H23.8z M34.7,32.8c-5.1,0-9.3-3.7-9.3-9.2c0-5.4,4.2-9.2,9.3-9.2c5.1,0,9.3,3.7,9.3,9.2 C44,29,39.8,32.8,34.7,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.5,0v47.1h21.7V0H71.5z M89.2,18.8h-8.8v3h7.8v3.8h-7.8v3h8.8v4H75.6V14.9h13.6V18.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoneLogoBlue);
export default __webpack_public_path__ + "static/media/kone-logo-blue.aa90dd8a4528a4800d193e3ec2fcd90f.svg";
export { ForwardRef as ReactComponent };